import { Fragment, useContext, useState } from 'react'

import SampleDataModal from 'src/components/common/SampleDataModal'
import DummyDataContext from 'src/context/dummyData'

import './sampleData.css'

const SampleData = () => {
    const hasSampleData = useContext(DummyDataContext)
    const [showSampleModal, setShowSampleModal] = useState(false)

    if (hasSampleData)
        return (
            <Fragment>
                <button
                    onClick={() => {
                        setShowSampleModal(true)
                    }}
                    className="items-cente mr-4 flex cursor-pointer rounded-sm p-2 py-1 text-primary-red-500 ring-1 ring-primary-red-500"
                >
                    CLEAR SAMPLE DATA
                </button>
                <SampleDataModal
                    showModal={showSampleModal}
                    closeModal={() => {
                        setShowSampleModal(false)
                    }}
                />
            </Fragment>
        )

    return null
}

export default SampleData
